// HashtagCategoryGrid.js
'use strict';
import { connect } from 'react-redux';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';

import fetchFeeds from '../action/fetchFeeds.js';

import HashtagCategoryGrid from '../component/HashtagCategoryGrid.jsx';

const mapStateToProps = (state, { category }) => {
  const nextPage = getListData(
    state,
    ['home', 'hashtags', category],
    'nextPage'
  );
  return {
    meId: getMeData(state, 'id'),
    nextPage,
    isNextPageFetching: !!getNetworkingData(
      state,
      ['home', 'hashtags', category, nextPage],
      'isFetching'
    ),
    hashtags: getListData(state, ['home', 'hashtags', category], 'itemIds'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: ({ type, page }) => dispatch(fetchFeeds({ type, page })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HashtagCategoryGrid);
